import React from 'react';

const Icons = {
    cart: 
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.698 30.667">
            <g transform="translate(0.75 0.75)">
                <path className="a" d="M9.75,25.333a2.917,2.917,0,1,0,2.917,2.917A2.913,2.913,0,0,0,9.75,25.333ZM1,3.458H1A1.463,1.463,0,0,0,2.458,4.917H3.917l5.25,11.069L7.2,19.544A2.922,2.922,0,0,0,9.75,23.875H25.792a1.463,1.463,0,0,0,1.458-1.458h0a1.463,1.463,0,0,0-1.458-1.458H9.75l1.6-2.917H22.219a2.9,2.9,0,0,0,2.552-1.5l5.221-9.465a1.453,1.453,0,0,0-1.269-2.158H7.14L6.162,2.831A1.448,1.448,0,0,0,4.85,2H2.458A1.463,1.463,0,0,0,1,3.458ZM24.333,25.333A2.917,2.917,0,1,0,27.25,28.25,2.913,2.913,0,0,0,24.333,25.333Z" transform="translate(-1 -2)"/>
            </g>
        </svg>,
    close: 
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" version="1.1"  x="0px" y="0px" width="69px" height="69px" viewBox="0 0 69 69" enableBackground="new 0 0 69 69">
            <g>
                <polygon fill="none" points="49.372,22.148 46.853,19.629 34.501,31.98 22.148,19.628 19.629,22.147 31.98,34.5 19.628,46.852 
                    22.148,49.371 34.5,37.02 46.853,49.371 49.371,46.853 37.02,34.501 	"/>
                <path d="M46.853,49.371L34.5,37.02L22.148,49.371l-2.52-2.52L31.98,34.5L19.629,22.147l2.52-2.52L34.501,31.98l12.352-12.352
                    l2.52,2.52L37.02,34.501l12.352,12.352L46.853,49.371z"/>
            </g>
        </svg>,
    leftPointer: 
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="595.279px" height="595.281px" viewBox="0 123.305 595.279 595.281" enableBackground="new 0 123.305 595.279 595.281">
            <path opacity="0.8" enableBackground="new" d="M595.28,420.948c0-164.383-133.258-297.641-297.64-297.641
                c-164.384,0-297.642,133.258-297.641,297.641c0,164.382,133.259,297.64,297.641,297.64
                C462.022,718.588,595.28,585.331,595.28,420.948z M116.064,417.901l171.168-146.035l12.98,15.215L158.863,407.676h305.864v20
                H157.218l143.425,127.246l-13.272,14.961L116.064,417.901z"/>
        </svg>,
    login: 
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.338 25.521">
            <g transform="translate(1 1)">
            <path className="a" d="M15.669,15.76A5.88,5.88,0,1,0,9.834,9.88,5.856,5.856,0,0,0,15.669,15.76Zm0,2.94C11.774,18.7,4,20.67,4,24.581v1.47a1.469,1.469,0,0,0,1.459,1.47h20.42a1.469,1.469,0,0,0,1.459-1.47v-1.47C27.338,20.67,19.563,18.7,15.669,18.7Z" transform="translate(-4 -4)"/></g>
        </svg>,
    plus: 
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="69px" height="69px" viewBox="0 0 69 69" enableBackground="new 0 0 69 69">
            <path d="M34.5,0C15.446,0,0,15.446,0,34.5S15.446,69,34.5,69S69,53.554,69,34.5S53.554,0,34.5,0z M53.75,36.281H36.281V53.75h-3.563
                V36.281H15.25v-3.563h17.469V15.25h3.563v17.469H53.75V36.281z"/>
        </svg>,
    rightPointer: 
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="595.279px" height="595.281px" viewBox="0 123.305 595.279 595.281"
            enableBackground="new 0 123.305 595.279 595.281">
            <path opacity="0.8"  enableBackground="new    " d="M-0.001,420.944c0,164.383,133.258,297.641,297.64,297.641
                c164.383,0,297.641-133.258,297.641-297.641c0-164.382-133.259-297.64-297.641-297.64C133.257,123.305-0.001,256.563-0.001,420.944z
                M479.216,423.992L308.048,570.027l-12.98-15.215l141.35-120.596H130.553v-20h307.508L294.636,286.971l13.272-14.961
                L479.216,423.992z"/>
        </svg>,
    scrolldown: 
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="595.279px" height="841.89px" viewBox="0 0 595.279 841.89" enableBackground="new 0 0 595.279 841.89">
            <path opacity="0.8"  d="M297.64,123.305c-164.383,0-297.641,133.258-297.641,297.64
                c0,164.382,133.258,297.64,297.641,297.64c164.382,0,297.64-133.258,297.64-297.64C595.28,256.563,462.022,123.305,297.64,123.305z
                M294.593,602.521L148.558,431.353l15.215-12.98l120.595,141.349V253.859h20v307.508l127.246-143.425l14.961,13.273L294.593,602.521
                z"/>
        </svg>,
    store: 
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 32">
            <g transform="translate(0 0)">
                <g className="a" transform="translate(0 8)">
                    <rect className="c" width="19.161" height="23.516" rx="3"/>
                    <rect className="d" x="1" y="1" width="17.161" height="21.516" rx="2"/>
                </g>
                <g className="b" transform="translate(6 3)">
                    <path className="c" d="M3.484,0A3.484,3.484,0,0,1,6.968,3.484H0A3.484,3.484,0,0,1,3.484,0Z"/>
                    <path className="e" d="M 3.483798027038574 -9.5367431640625e-07 C 1.55974817276001 -9.5367431640625e-07 -1.9073486328125e-06 1.559749007225037 -1.9073486328125e-06 3.483798980712891 L 6.967597961425781 3.483798980712891 C 6.967597961425781 1.559749007225037 5.407847881317139 -9.5367431640625e-07 3.483798027038574 -9.5367431640625e-07 M 3.483798027038574 -2.000000953674316 C 6.507577896118164 -2.000000953674316 8.967597961425781 0.4600191116333008 8.967597961425781 3.483798980712891 L 8.967597961425781 5.483798980712891 L 6.967597961425781 5.483798980712891 L -1.9073486328125e-06 5.483798980712891 L -2.000001907348633 5.483798980712891 L -2.000001907348633 3.483798980712891 C -2.000001907348633 0.4600191116333008 0.4600181579589844 -2.000000953674316 3.483798027038574 -2.000000953674316 Z"/>
                </g>
            </g>
        </svg>,
    logo:
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="123.304px" height="109.192px" viewBox="0 366.161 123.304 109.192"
            enableBackground="new 0 366.161 123.304 109.192">
            <g transform="translate(0 71.372)">
            <g transform="translate(0 -71.372)">
                <path fill="#FFFFFF" d="M15.222,471.482l7.231-12.211l35.424,16.082l9.506-16.111l35.103,15.91l10.424-17.52l10.395-74.498
                    l-36.306-16.518l-9.471,15.984l-35.361-16.083l-8.896,14.802L0,366.161L15.222,471.482z M70.37,456.984l10.156-72.968
                    l6.361-10.755l14.108,97.699L70.37,456.984z M25.348,456.984l10.162-72.968l6.367-10.755l14.126,97.688L25.348,456.984z"/>
            </g>
            </g>
        </svg>,
    menu: 
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            width="50px" height="50px" viewBox="0 0 50 50" enableBackground="new 0 0 50 50">
            <line fill="none" x1="0" y1="0" x2="50" y2="0"/>
            <line fill="none" x1="0" y1="25" x2="50" y2="25"/>
            <line fill="none" x1="0" y1="50" x2="50" y2="50"/>
        </svg>
}

export default Icons;


// WEBPACK FOOTER //
// ./src/assets/icons/icons.js